/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import React from 'react';

// UI lib dependencies;
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

// Style
import styles from './styles';

import { getLabelByValue } from 'utils/languages';
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function CellLanguages({ languages }) {
  /* ********************************** HOOKS ********************************* */
  const { t } = useTranslation();
  /* ******************************** HELPERS ******************************* */

  function transformChaine(input) {
    input = input.replace(/ /g, '');
    const elements = input.split(',');
    let output = '';

    for (let i = 0; i < elements.length; i++) {
      output += t(getLabelByValue(elements[i]));
      if (i < elements.length - 1) {
        output += ', ';
      }
    }

    return output;
  }
  /* ******************************** RENDERING ******************************* */

  return (
    <Stack alignItems={'center'} direction={'row'} data-tag="allowRowEvents">
      <Tooltip
        title={transformChaine(languages) && transformChaine(languages).length > 18 ? transformChaine(languages) : ''}>
        <Typography sx={styles.cellText}>{transformChaine(languages)}</Typography>
      </Tooltip>
    </Stack>
  );
}

export default CellLanguages;
